import { components } from "@certn/legacy-api/generated-schemas/people";

import { ValidationRuleType } from "./types";

export function requireEmploymentsRule(
  rule: components["schemas"]["RequireEmploymentsRule"]
): ValidationRuleType {
  return {
    rule,
    isValid: (
      employers: components["schemas"]["EmploymentCheckFieldValue"][]
    ) => {
      const contactableEmployers = employers.filter(
        ({ can_contact }) => !!can_contact
      );
      return contactableEmployers?.length >= rule.min;
    },
  };
}
